import { ROUTES } from '~/utils/routes';
import { useEditBranchFormHeader } from './hooks';
import { EditBranchFormHeaderPresentation } from './presentations';

type Props = {
  branchId: number;
};

export const EditBranchFormHeader: React.FC<Props> = ({ branchId }) => {
  const { branchName } = useEditBranchFormHeader({ branchId });

  return (
    <EditBranchFormHeaderPresentation branchName={branchName} indexHref={ROUTES.BRANCHES.INDEX} />
  );
};
